import { createContext, FunctionComponent, useState } from 'react';

import { ChangeDetectorContextModel } from './models/change-detector-context.model';

export const ChangeDetectorContext =
  createContext<ChangeDetectorContextModel | null>(null);

const ChangeDetectorContextProvider: FunctionComponent = ({
  children,
}): JSX.Element => {
  const [isChanged, _setIsChanged] = useState<boolean>(false);

  const setIsChanged = (state: boolean): void => {
    _setIsChanged(state);
  };

  return (
    <ChangeDetectorContext.Provider value={{ isChanged, setIsChanged }}>
      {children}
    </ChangeDetectorContext.Provider>
  );
};

export default ChangeDetectorContextProvider;
